// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"061ab221","465":"7ef08e99","478":"894a9468","776":"c147c0cd","851":"1acca0c2","868":"d33ce261"}[chunkId] + ".css";
};